import { z } from "zod";
const accessMagicLinkRequestSchema = z.object({
  uuid: z.string()
});
function accessMagicLink({
  client,
  params
}) {
  const { uuid } = accessMagicLinkRequestSchema.parse(params);
  return client.url(`/api/v1/m/${uuid}`).get().res();
}
const beginPasswordResetRequestSchema = z.object({
  email: z.string().email(),
  languageCode: z.string(),
  requestor: z.string().optional(),
  redirectAfterReset: z.string().optional()
});
function beginPasswordReset({
  client,
  params
}) {
  return client.url("/api/v1/users/begin-password-reset").post(beginPasswordResetRequestSchema.parse(params)).res();
}
const createNewPasswordRequestSchema = z.object({
  password: z.string(),
  token: z.string()
});
const createNewPasswordResponseSchema = z.object({});
function createNewPassword({
  client,
  params
}) {
  return client.url("/api/v1/users/password").post(createNewPasswordRequestSchema.parse(params)).valid(createNewPasswordResponseSchema);
}
const createUserRequestSchema = z.object({
  email: z.string().email(),
  password: z.string()
});
const createUserResponseSchema = z.object({
  uuid: z.string().uuid(),
  email: z.string().email()
});
function createUser({
  client,
  params
}) {
  return client.url("/api/v1/users").post(createUserRequestSchema.parse(params)).valid(createUserResponseSchema);
}
const loginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string()
});
const loginResponseSchema = z.object({});
function login({ client, params }) {
  return client.url("/api/v1/auth/login").post(loginRequestSchema.parse(params)).valid(loginResponseSchema);
}
async function logout({ client }) {
  await client.url("/api/v1/auth/logout").post().res();
}
export {
  accessMagicLinkRequestSchema as a,
  accessMagicLink as b,
  beginPasswordResetRequestSchema as c,
  beginPasswordReset as d,
  createNewPasswordRequestSchema as e,
  createNewPasswordResponseSchema as f,
  createNewPassword as g,
  createUserRequestSchema as h,
  createUserResponseSchema as i,
  createUser as j,
  loginResponseSchema as k,
  loginRequestSchema as l,
  login as m,
  logout as n
};
//# sourceMappingURL=logout-yCeX-sS8.js.map
